module.exports = __webpack_public_path__ + "img/project-7.ca89a56b.jpg";